/* Momentum Crunch storefront — ported from the approved mockup onto Shopify's Cart API.
   Cart drawer with Upgrade-to-subscribe and delivery-rhythm changes (the OOTW flow), product cards,
   product page pricing, rhythm finder, review filters, and the motion layer. */
(function () {
  "use strict";
  var MC = window.MC = window.MC || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return [].slice.call((r || document).querySelectorAll(s)); };
  var reduce = matchMedia("(prefers-reduced-motion: reduce)").matches;
  var finePointer = matchMedia("(pointer: fine)").matches;
  var lerp = function (a, b, t) { return a + (b - a) * t; };

  /* ---------------- money + plans ---------------- */
  function money(cents) {
    var fmt = MC.moneyFormat || "${{amount}}";
    var n = (Math.round(cents) / 100);
    var withSep = function (x, d, ts, ds) {
      var p = x.toFixed(d).split("."); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts); return p.join(ds);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === "amount_no_decimals") return withSep(n, 0, ",", ".");
      if (k === "amount_with_comma_separator") return withSep(n, 2, ".", ",");
      if (k === "amount_no_decimals_with_comma_separator") return withSep(n, 0, ".", ",");
      return withSep(n, 2, ",", ".");
    });
  }
  MC.money = money;
  function planDays(p) {
    var t = ((p.opt || "") + " " + (p.name || "")).toLowerCase();
    var m = t.match(/(\d+)\s*-?\s*(day|week|month)/);
    if (!m) return null;
    return +m[1] * (m[2] === "week" ? 7 : m[2] === "month" ? 30 : 1);
  }
  function planLabel(p) { var d = planDays(p); return d ? "Every " + d + " days" : (p.opt || p.name); }
  function pickPlan(plans, days) {
    days = days || 28;
    var best = null, bd = 1e9;
    (plans || []).forEach(function (p) { var d = planDays(p); var diff = d == null ? 999 : Math.abs(d - days); if (diff < bd) { bd = diff; best = p; } });
    return best;
  }
  MC.planDays = planDays; MC.pickPlan = pickPlan;
  var readJSON = function (el) { try { return JSON.parse(el.textContent); } catch (e) { return null; } };

  /* ---------------- toast ---------------- */
  var tt;
  function toast(m) {
    var t = $("[data-mc-toast]"); if (!t) return;
    t.textContent = m; t.hidden = false; clearTimeout(tt); tt = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* ---------------- cart ---------------- */
  var productCache = {};
  function productData(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    var el = $('[data-mc-xsell="' + handle + '"]') || $('[data-mc-product="' + handle + '"]');
    if (el) { var d = readJSON(el); if (d) { productCache[handle] = d; return Promise.resolve(d); } }
    return fetch("/products/" + encodeURIComponent(handle) + "?view=mc-data", { credentials: "same-origin" })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) { if (d) productCache[handle] = d; return d; })
      .catch(function () { return null; });
  }
  function api(url, body) {
    return fetch(url + ".js", { method: "POST", credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function getCart() { return fetch("/cart.js", { credentials: "same-origin" }).then(function (r) { return r.json(); }); }

  var drawer, scrim, lastFocus = null, cartState = null;
  function openCart() {
    if (!drawer) return;
    lastFocus = document.activeElement; scrim.hidden = false; drawer.hidden = false;
    var c = $("[data-mc-cart-close]"); if (c) c.focus();
  }
  function closeCart() {
    if (!drawer) return;
    scrim.hidden = true; drawer.hidden = true; if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function busy(on) { if (drawer) drawer.classList.toggle("is-busy", !!on); }

  function renderCart(cart) {
    cartState = cart;
    var handles = cart.items.map(function (i) { return i.handle; });
    return Promise.all(handles.map(productData)).then(function (datas) {
      var by = {}; datas.forEach(function (d, i) { if (d) by[handles[i]] = d; });
      var bagsOf = function (it) { return ((by[it.handle] || {}).bags || 1) * it.quantity; };
      var bags = cart.items.reduce(function (a, it) { return a + bagsOf(it); }, 0);
      $$("[data-mc-count]").forEach(function (c) { c.textContent = bags; c.hidden = bags === 0; });
      if (!drawer) return;
      var list = 0;
      cart.items.forEach(function (it) {
        var each = it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price ? it.selling_plan_allocation.compare_at_price : it.original_price;
        list += Math.max(each, it.original_price) * it.quantity;
      });
      var total = cart.total_price, saved = list - total;
      $("[data-mc-subtotal]").textContent = money(total);
      $("[data-mc-saved-row]").hidden = saved <= 0; $("[data-mc-saved]").textContent = money(Math.max(0, saved));
      var fs = MC.freeShip || 15000, free = total >= fs;
      var ship = $("[data-mc-ship]");
      ship.innerHTML = !cart.items.length
        ? "Free shipping on orders over " + money(fs).replace(/\.00$/, "") + '.<div class="bar"><i style="width:0"></i></div>'
        : free ? '<b style="color:var(--ok)">✓</b> Congrats, your order ships free.<div class="bar"><i style="width:100%"></i></div>'
        : "You're " + money(fs - total) + ' away from free shipping.<div class="bar"><i style="width:' + Math.min(100, total / fs * 100) + '%"></i></div>';

      var lines = $("[data-mc-lines]");
      lines.replaceChildren();
      if (!cart.items.length) {
        lines.innerHTML = '<div class="empty">Your cart is empty.<br>Find your state to get moving.</div>';
      }
      cart.items.forEach(function (it) {
        var d = by[it.handle] || {}, b = bagsOf(it), plans = d.plans || [];
        var row = document.createElement("div"); row.className = "line"; row.dataset.key = it.key;
        var img = document.createElement("img"); img.alt = ""; img.width = 64; img.height = 90;
        if (it.image) img.src = it.image + (it.image.indexOf("?") > -1 ? "&" : "?") + "width=160"; row.appendChild(img);
        var mid = document.createElement("div");
        var h = document.createElement("h3"); var a = document.createElement("a"); a.href = it.url; a.textContent = it.product_title; h.appendChild(a); mid.appendChild(h);
        var sub = document.createElement("div"); sub.className = "sub";
        sub.textContent = (d.flavour ? d.flavour + " · " : "") + b + (b > 1 ? " bags" : " bag"); mid.appendChild(sub);
        if (it.selling_plan_allocation) {
          var curId = it.selling_plan_allocation.selling_plan.id;
          var lab = document.createElement("label"); lab.className = "sub"; lab.htmlFor = "fq-" + it.key; lab.textContent = "Subscription · "; mid.appendChild(lab);
          if (plans.length > 1) {
            var sel = document.createElement("select"); sel.id = "fq-" + it.key; sel.dataset.freq = it.key; sel.setAttribute("aria-label", "Delivery frequency");
            plans.forEach(function (p) { var o = document.createElement("option"); o.value = p.id; o.textContent = planLabel(p).replace(/^Every/, "every"); if (p.id === curId) o.selected = true; sel.appendChild(o); });
            mid.appendChild(sel);
          } else {
            var sp = document.createElement("span"); sp.className = "sub"; sp.textContent = planLabel(it.selling_plan_allocation.selling_plan); mid.appendChild(sp);
          }
        } else {
          var once = document.createElement("div"); once.className = "sub"; once.textContent = "Try once"; mid.appendChild(once);
          var plan = pickPlan(plans, 28);
          if (plan && !d.requiresPlan) {
            var save = it.final_line_price - plan.price * it.quantity;
            var up = document.createElement("div"); up.className = "upgrade";
            up.appendChild(document.createTextNode(save > 0 ? "Save " + money(save) + " " : "Subscribe "));
            var btn = document.createElement("button"); btn.type = "button"; btn.dataset.upgrade = it.key; btn.dataset.plan = plan.id; btn.textContent = "Upgrade to subscribe";
            up.appendChild(btn); mid.appendChild(up);
          }
        }
        var qty = document.createElement("div"); qty.className = "qty";
        qty.innerHTML = '<button type="button" data-qty="-1" aria-label="One fewer">−</button><span></span><button type="button" data-qty="1" aria-label="One more">+</button>';
        qty.querySelector("span").textContent = it.quantity; qty.dataset.key = it.key; mid.appendChild(qty);
        mid.appendChild(document.createElement("br"));
        var rm = document.createElement("button"); rm.type = "button"; rm.className = "rm"; rm.dataset.rm = it.key; rm.textContent = "Remove"; mid.appendChild(rm);
        row.appendChild(mid);
        var pr = document.createElement("div"); pr.className = "price"; pr.textContent = money(it.final_line_price);
        var listLine = (it.selling_plan_allocation && it.selling_plan_allocation.compare_at_price ? it.selling_plan_allocation.compare_at_price : it.original_price) * it.quantity;
        if (listLine > it.final_line_price) { var s = document.createElement("div"); s.className = "sub"; s.innerHTML = "<s></s>"; s.firstChild.textContent = money(listLine); pr.appendChild(s); }
        (it.line_level_discount_allocations || []).forEach(function (da) {
          var dd = document.createElement("div"); dd.className = "disc"; dd.textContent = da.discount_application.title; pr.appendChild(dd);
        });
        row.appendChild(pr);
        lines.appendChild(row);
      });

      // try-both cross-sell
      var ups = $("[data-mc-upsell]"), xs = $$("[data-mc-xsell]").map(function (e) { return e.dataset.mcXsell; });
      var hasBundle = cart.items.some(function (it) { return ((by[it.handle] || {}).bags || 1) > 1; });
      var inCart = xs.filter(function (h) { return handles.indexOf(h) > -1; });
      var missing = xs.filter(function (h) { return handles.indexOf(h) === -1; });
      if (!hasBundle && inCart.length && missing.length) {
        productData(missing[0]).then(function (o) {
          if (!o) { ups.hidden = true; return; }
          var plan = pickPlan(o.plans, 28);
          ups.hidden = false; ups.replaceChildren();
          var im = document.createElement("img"); im.alt = ""; im.src = o.img; ups.appendChild(im);
          var tx = document.createElement("div"); var bb = document.createElement("b"); bb.textContent = "Add " + o.title; tx.appendChild(bb);
          var ss = document.createElement("span"); ss.textContent = "Try both flavors · " + money(plan ? plan.price : o.price) + (plan ? " on subscription" : ""); tx.appendChild(ss); ups.appendChild(tx);
          var ab = document.createElement("button"); ab.type = "button"; ab.textContent = "Add"; ab.dataset.xadd = o.handle; ups.appendChild(ab);
        });
      } else if (ups) ups.hidden = true;
      var co = $("[data-mc-checkout]"); if (co) co.disabled = !cart.items.length;
    });
  }
  function refresh() { return getCart().then(renderCart); }
  MC.refreshCart = refresh;

  function add(items, label) {
    if (ordersClosed()) { launchPopup(); return Promise.resolve(); }
    busy(true);
    return api(MC.routes && MC.routes.add || "/cart/add", { items: items })
      .then(function () { return refresh(); })
      .then(function () { openCart(); if (label) toast(label); })
      .catch(function (e) { toast((e && (e.description || e.message)) || "That didn't add. Please try again."); })
      .then(function () { busy(false); });
  }
  MC.add = add;
  function change(body, label) {
    busy(true);
    return api(MC.routes && MC.routes.change || "/cart/change", body)
      .then(renderCart).then(function () { if (label) toast(label); })
      .catch(function (e) { toast((e && (e.description || e.message)) || "That didn't update. Please try again."); })
      .then(function () { busy(false); });
  }
  function lineByKey(k) { return cartState && cartState.items.filter(function (i) { return i.key === k; })[0]; }

  function initCart() {
    drawer = $("[data-mc-drawer]"); scrim = $("[data-mc-scrim]");
    $$("[data-mc-cart-open]").forEach(function (b) { b.addEventListener("click", function (e) { if (ordersClosed()) { e.preventDefault(); return launchPopup(); } if (!drawer) return; e.preventDefault(); refresh(); openCart(); }); });
    if (!drawer) return;
    $("[data-mc-cart-close]").addEventListener("click", closeCart);
    scrim.addEventListener("click", closeCart);
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !drawer.hidden) closeCart(); });
    drawer.addEventListener("click", function (e) {
      var t = e.target;
      var rm = t.closest("[data-rm]"); if (rm) return change({ id: rm.dataset.rm, quantity: 0 });
      var q = t.closest("[data-qty]"); if (q) { var l = lineByKey(q.parentNode.dataset.key); if (l) change({ id: l.key, quantity: Math.max(0, l.quantity + +q.dataset.qty) }); return; }
      var u = t.closest("[data-upgrade]");
      if (u) { var ln = lineByKey(u.dataset.upgrade); if (ln) change({ id: ln.key, quantity: ln.quantity, selling_plan: +u.dataset.plan }, "Upgraded to subscribe & save · every 28 days"); return; }
      var x = t.closest("[data-xadd]");
      if (x) { productData(x.dataset.xadd).then(function (o) { if (!o) return; var p = pickPlan(o.plans, 28);
        var item = { id: o.variant, quantity: 1 }; if (p) item.selling_plan = p.id;
        add([item], "Added " + o.title + (p ? " · every " + planDays(p) + " days" : "")); }); }
    });
    drawer.addEventListener("change", function (e) {
      var s = e.target.closest("[data-freq]"); if (!s) return;
      var ln = lineByKey(s.dataset.freq); if (!ln) return;
      var label = s.options[s.selectedIndex].textContent;
      change({ id: ln.key, quantity: ln.quantity, selling_plan: +s.value }, "Delivery changed to " + label);
    });
    refresh();
  }

  /* ---------------- pre-launch: no checkout, send people to the waitlist ----------------
     Add to Cart, the cart icon and Checkout all open the waitlist pop-up with the launch countdown. */
  function ordersClosed() { return document.body.classList.contains("mc-orders-closed") && !!window.MCPopup; }
  function launchPopup() { closeCart(); window.MCPopup.open("wait", { cart: true }); }
  function initOrdersClosed() {
    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-mc-orders-closed]")) {
        if (window.MCPopup) return launchPopup();
        var n = $("[data-mc-drawer] [data-mc-orders-closed-note]"); if (n) { n.hidden = false; var b = $("[data-mc-join-waitlist]", n); if (b) b.focus(); }
        return;
      }
      if (e.target.closest("[data-mc-join-waitlist]")) {
        if (window.MCPopup) launchPopup(); else location.href = "/pages/subscribe";
      }
    });
  }

  /* ---------------- product cards ---------------- */
  function initCards() {
    document.addEventListener("submit", function (e) {
      var f = e.target.closest("[data-mc-card-form]"); if (!f) return;
      e.preventDefault();
      var d = readJSON($("[data-mc-product]", f)); if (!d) return f.submit();
      var chosen = $("input[type=radio]:checked", f);
      var sub = chosen && chosen.value === "sub";
      var item = { id: d.variant, quantity: 1 }, plan = sub ? pickPlan(d.plans, 28) : null;
      if (plan) item.selling_plan = plan.id;
      add([item], "Added " + d.title + (plan ? " · every " + planDays(plan) + " days" : ""));
    });
  }

  /* ---------------- product page ---------------- */
  function initPDP() {
    var root = $("[data-mc-pdp]"); if (!root) return;
    var d = readJSON($("[data-mc-product]", root)); if (!d) return;
    var form = $("[data-mc-pdp-form]", root) || $("#mc-pdp-form");
    var serv = +root.dataset.servings || 9, fs = MC.freeShip || 15000;
    var tiersOn = root.dataset.tiers === "true";
    var eachOne = function () { var r = $("input[name=mc-tier]:checked", root); var pct = tiersOn && r ? +(r.dataset.pct || 0) : 0; return Math.round(d.price * (100 - pct) / 100); };
    var n = function () { var r = $("input[name=mc-tier]:checked", root); return tiersOn && r ? +r.value : 1; };
    var isSub = function () { var r = $("input[name=mc-plan]:checked", root); return !!r && r.value === "sub"; };
    var planId = function () { var r = $("input[name=mc-freq]:checked", root); return r ? +r.value : null; };
    var planFor = function (id) { return d.plans.filter(function (p) { return p.id === id; })[0]; };

    // normalise plan labels ("Every 28 days") and default to the ~28-day plan
    var def = pickPlan(d.plans, 28);
    $$("input[name=mc-freq]", root).forEach(function (r) {
      var p = planFor(+r.value); if (!p) return;
      r.nextElementSibling.textContent = planLabel(p);
      if (def && p.id === def.id) r.checked = true;
    });

    function update() {
      var q = n(), sub = isSub(), plan = planFor(planId());
      var subEach = plan ? plan.price : (d.plans[0] ? d.plans[0].price : d.price);
      var s = subEach * q, o = eachOne(q) * q, l = d.price * q;
      var sp = $("[data-sub-price]", root); if (sp) sp.innerHTML = money(s) + "<s>" + money(l) + "</s>";
      var op = $("[data-one-price]", root); if (op) op.innerHTML = o < l ? money(o) + "<s>" + money(l) + "</s>" : money(o);
      var bags = d.bags * q, why = $("[data-why]", root);
      var days = plan ? planDays(plan) : 28;
      if (why) why.textContent = bags === 1
        ? "A bag is about " + serv + " servings. As a daily handful, every 14 days keeps you stocked."
        : bags + " bags is about " + bags * serv + " servings. As a daily handful, every 28 days keeps you stocked.";
      var total = sub ? s : o;
      var ap = $("[data-add-price]", root); if (ap) ap.textContent = money(total);
      var free = total >= fs;
      var os = $("[data-one-ship]", root); if (os) os.textContent = o >= fs ? "Ships free" : "Free shipping on orders " + money(fs).replace(/\.00$/, "") + "+";
      var sn = $("[data-ship-note]", root.parentNode);
      if (sn) sn.innerHTML = free ? "<b>✓ Free shipping</b> on this order" : "Add " + money(fs - total) + " more for free shipping";
      var ss = $("[data-sticky-sub]"); if (ss) ss.textContent = (d.plans.length ? (sub ? "Subscribe & save · " : "Try once · ") : "") + money(total);
      $("[data-qty]", form).value = q;
      $("[data-plan-input]", form).value = sub && plan ? plan.id : "";
      void days;
    }
    root.addEventListener("change", function (e) {
      if (e.target.name === "mc-freq") { var sr = $("input[name=mc-plan][value=sub]", root); if (sr) sr.checked = true; }
      update();
    });
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      var item = { id: d.variant, quantity: n() }, sub = isSub(), plan = planFor(planId());
      if (sub && plan) item.selling_plan = plan.id;
      var btn = $("#addBtn"); btn.classList.add("is-loading");
      add([item], "Added " + d.title + (sub && plan ? " · every " + planDays(plan) + " days" : "")).then(function () { btn.classList.remove("is-loading"); });
    });
    // gallery
    var main = $("[data-g-main]", root);
    root.addEventListener("click", function (e) {
      var th = e.target.closest(".thumb"); if (!th || !main) return;
      main.removeAttribute("srcset"); main.src = th.dataset.img; main.alt = th.dataset.alt || "";
      main.classList.toggle("cut", th.dataset.cut === "1"); main.classList.toggle("photo", th.dataset.cut !== "1");
      $$(".thumb", root).forEach(function (b) { b.setAttribute("aria-pressed", String(b === th)); });
    });
    // sticky mobile add-to-cart
    var sticky = $("#stickyBuy"), addBtn = $("#addBtn");
    if (sticky && addBtn && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle("show", !en[0].isIntersecting); }).observe(addBtn);
      var sa = $("[data-sticky-add]"); if (sa) sa.addEventListener("click", function () { addBtn.click(); });
    }
    update();
  }

  /* ---------------- rhythm finder ---------------- */
  function initFinder() {
    $$("[data-mc-finder]").forEach(function (root) {
      var serv = +root.dataset.servings || 9, data = {};
      $$("[data-mc-product]", root).forEach(function (el) { var j = readJSON(el); if (j) data[el.dataset.mcProduct] = j; });
      var val = function (n) { var r = $('input[name="' + n + '"]:checked', root); return r ? r.value : null; };
      function recommend() {
        var people = +val("people"), spd = +val("spd"), key = val("fflav"), p = data[key]; if (!p) return;
        var daily = people * spd, perUnit = p.bags * serv, best = null;
        var freqs = p.plans.map(planDays).filter(Boolean); if (!freqs.length) freqs = [14, 28, 42];
        freqs.forEach(function (f) { for (var k = 1; k <= 4; k++) {
          var lasts = k * perUnit / daily, short = lasts < f * 0.9, score = Math.abs(lasts - f) + (short ? 100 : 0) + k * 0.5;
          if (!best || score < best.score) best = { f: f, n: k, lasts: lasts, score: score }; } });
        var plan = pickPlan(p.plans, best.f), bundle = p.bags > 1;
        var unit = bundle ? (best.n > 1 ? "Duos" : "Duo") : (best.n > 1 ? "bags" : "bag");
        var label = bundle ? best.n + " " + unit : best.n + " " + p.title + " " + unit;
        $("[data-rec-big]", root).textContent = label + " every " + best.f + " days";
        $("[data-rec-why]", root).textContent = "That's about " + best.n * perUnit + " servings, enough for roughly " + Math.round(best.lasts) + " days at your pace.";
        $("[data-rec-price]", root).textContent = money((plan ? plan.price : p.price) * best.n) + " per delivery" + ((plan ? plan.price : p.price) * best.n >= (MC.freeShip || 15000) ? " · ships free" : "");
        var b = $("[data-rec-add]", root);
        b.textContent = plan ? "Start This Subscription" : "Add to Cart";
        b.onclick = function () { var item = { id: p.variant, quantity: best.n }; if (plan) item.selling_plan = plan.id;
          add([item], "Added " + label + (plan ? " · every " + planDays(plan) + " days" : "")); };
      }
      root.addEventListener("change", recommend); recommend();
    });
  }

  /* ---------------- reviews ---------------- */
  function initReviews() {
    var root = $("[data-mc-reviews]");
    if (root) {
      var list = $("[data-rv-list]", root), cards = $$(".rv-card", list), filt = { flavour: "all", stars: 0, sort: "new" };
      var apply = function () {
        var shown = cards.filter(function (c) {
          var ok = (filt.flavour === "all" || c.dataset.flavour === filt.flavour) && (!filt.stars || +c.dataset.rating === filt.stars);
          c.hidden = !ok; return ok; });
        shown.sort(function (a, b) {
          var da = +a.dataset.date, db = +b.dataset.date, ra = +a.dataset.rating, rb = +b.dataset.rating;
          return filt.sort === "high" ? rb - ra || db - da : filt.sort === "low" ? ra - rb || db - da : db - da; })
          .forEach(function (c) { list.appendChild(c); });
        var nm = $("[data-rv-nomatch]", root); if (nm) nm.hidden = !(cards.length && !shown.length);
      };
      root.addEventListener("click", function (e) {
        var f = e.target.closest("[data-rv-flavour]");
        if (f) { filt.flavour = f.dataset.rvFlavour; $$("[data-rv-flavour]", root).forEach(function (b) { b.setAttribute("aria-pressed", String(b === f)); }); apply(); }
        var s = e.target.closest("[data-rv-stars]");
        if (s) { var v = +s.dataset.rvStars; filt.stars = filt.stars === v ? 0 : v;
          $$("[data-rv-stars]", root).forEach(function (b) { b.setAttribute("aria-pressed", String(+b.dataset.rvStars === filt.stars)); }); apply(); }
      });
      var so = $("[data-rv-sort]", root); if (so) so.addEventListener("change", function () { filt.sort = so.value; apply(); });
    }
    $$("[data-mc-count-target]").forEach(function (ta) {
      var out = ta.closest("form").querySelector("[data-mc-count-for]"); if (!out) return;
      var upd = function () { out.textContent = ta.value.length + " / " + (ta.maxLength > 0 ? ta.maxLength : 1200); };
      ta.addEventListener("input", upd); upd();
    });
  }

  /* ---------------- review forms: publish straight to the site ---------------- */
  function initReviewForms() {
    var API = (document.getElementById("mcp") || { dataset: {} }).dataset.api || "https://momentum-crunch-preview.vercel.app";
    var FLAV = { balance: "balance", release: "release", "the-duo": "duo" };
    $$("[data-mc-review-form]").forEach(function (f) {
      var status = $(".rv-status", f), say = function (m, k) { if (status) { status.textContent = m; status.className = "rv-status" + (k ? " " + k : ""); } };
      f.addEventListener("submit", function (e) {
        e.preventDefault();
        var g = function (n) { var el = f.elements[n]; return el ? (el.value || "").trim() : ""; };
        var r = $('input[name="contact[Rating]"]:checked', f);
        var data = { rating: r ? parseInt(r.value, 10) : 0, flavour: FLAV[g("contact[Product]")] || "balance", name: g("contact[name]"),
                     title: g("contact[Headline]"), body: g("contact[body]"), connection: g("contact[How they got it]") };
        if (!data.rating) return say("Choose a star rating.", "err");
        if (!data.name) return say("Add the name you'd like shown with your review.", "err");
        if (!data.connection) return say("Tell us how you got your Momentum Crunch.", "err");
        if (data.body.length < 10) return say("Write at least a sentence so it helps someone decide.", "err");
        var btn = $('button[type="submit"]', f); btn.disabled = true; say("Posting…");
        fetch(API + "/api/review", { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(data) })
          .then(function (res) { return res.json(); })
          .then(function (j) {
            btn.disabled = false;
            if (!j.ok) return say(j.error || "That didn't save. Please try again.", "err");
            f.reset();
            if (j.live) { say("Thank you! Your review is up on the site.", "ok"); setTimeout(function () { location.reload(); }, 1400); }
            else say("Thank you! Your review is with us and will appear once we've checked it.", "ok");
          })
          .catch(function () { btn.disabled = false; say("Check your connection and try again.", "err"); });
      });
    });
  }

  /* ---------------- header bits ---------------- */
  function initHeader() {
    var mMenu = $("#mMenu"), menuBtn = $("#menuBtn");
    if (mMenu && menuBtn) {
      var close = function () { mMenu.hidden = true; menuBtn.setAttribute("aria-expanded", "false"); };
      menuBtn.addEventListener("click", function () { mMenu.hidden = !mMenu.hidden; menuBtn.setAttribute("aria-expanded", String(!mMenu.hidden)); });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !mMenu.hidden) { close(); menuBtn.focus(); } });
      mMenu.addEventListener("click", function (e) { if (e.target.closest("a")) close(); });
    }
    $$("[data-mc-announce]").forEach(function (bar) {
      var msgs = $$(".msg", bar); if (msgs.length < 2 || reduce) return;
      var i = 0, ms = +bar.dataset.interval || 4800;
      setInterval(function () {
        var cur = msgs[i]; cur.style.opacity = 0;
        setTimeout(function () { cur.hidden = true; i = (i + 1) % msgs.length; msgs[i].style.opacity = 0; msgs[i].hidden = false;
          requestAnimationFrame(function () { msgs[i].style.opacity = 1; }); }, 350);
      }, ms);
    });
    $$("[data-mc-copy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var el = $(b.dataset.mcCopy); if (!el) return;
        var done = function () { b.textContent = "Copied"; setTimeout(function () { b.textContent = "Copy"; }, 1600); };
        if (navigator.clipboard) navigator.clipboard.writeText(el.textContent.trim()).then(done, function () { getSelection().selectAllChildren(el); });
        else getSelection().selectAllChildren(el);
      });
    });
  }

  /* ---------------- motion layer (home) ---------------- */
  function initWords() {
    $$("[data-mc-words]").forEach(function (sec) {
      var big = $("[data-big-word]", sec), lis = $$(".word-dots li", sec); if (!big || !lis.length) return;
      var i = 0, timer = null, hasG = !!window.gsap;
      function show(k) {
        i = k; big.textContent = lis[i].dataset.word;
        lis.forEach(function (li, j) { li.classList.toggle("on", j === i); li.setAttribute("aria-pressed", String(j === i)); });
        if (hasG && !reduce) gsap.fromTo(big, { yPercent: 40, opacity: 0.2, filter: "blur(6px)" }, { yPercent: 0, opacity: 1, filter: "blur(0px)", duration: 0.55, ease: "power3.out", overwrite: true });
      }
      var start = function () { clearInterval(timer); if (!reduce) timer = setInterval(function () { show((i + 1) % lis.length); }, 1900); };
      lis.forEach(function (li, k) {
        li.tabIndex = 0; li.setAttribute("role", "button");
        li.addEventListener("click", function () { show(k); start(); });
        li.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); show(k); start(); } });
      });
      show(0);
      new IntersectionObserver(function (en) { if (en[0].isIntersecting) start(); else clearInterval(timer); }, { threshold: 0.3 }).observe(sec);
    });
  }
  function initScroll() {
    if (!window.gsap || !window.ScrollTrigger || reduce) return;
    gsap.registerPlugin(ScrollTrigger);
    if ($(".kin span")) {
      gsap.from(".kin span", { yPercent: 38, rotateX: -55, opacity: 0.25, duration: 1.2, ease: "expo.out", stagger: 0.055, delay: 0.1 });
      gsap.from(".h3d .lede, .h3d .hero-ctas, .h3d .assure", { y: 18, opacity: 0.4, duration: 1, ease: "power3.out", stagger: 0.08, delay: 0.45 });
      gsap.to(".h3d-copy", { yPercent: -18, opacity: 0.35, ease: "none", scrollTrigger: { trigger: ".h3d", start: "top top", end: "bottom top", scrub: true } });
    }
    $$(".fz").forEach(function (el) {
      var sp = +el.dataset.speed || 1, spin = +el.dataset.spin || 0;
      gsap.fromTo(el, { y: 90 * sp, rotate: -spin / 2 }, { y: -90 * sp, rotate: spin, ease: "none", scrollTrigger: { trigger: el.closest(".frozen"), start: "top bottom", end: "bottom top", scrub: true } });
    });
    $$("[data-mc-words]").forEach(function (sec) {
      gsap.fromTo($(".words-photo .mask", sec), { clipPath: "circle(47% at 50% 48%)" }, { clipPath: "circle(72% at 50% 48%)", ease: "none", scrollTrigger: { trigger: sec, start: "top bottom", end: "bottom top", scrub: true } });
      gsap.fromTo($(".words-photo img", sec), { scale: 1.12 }, { scale: 1, ease: "none", scrollTrigger: { trigger: sec, start: "top bottom", end: "bottom top", scrub: true } });
    });
    $$(".reveal-circle img").forEach(function (img) {
      gsap.fromTo(img, { clipPath: "circle(44% at 50% 50%)" }, { clipPath: "circle(76% at 50% 50%)", ease: "none", scrollTrigger: { trigger: img.parentNode, start: "top 85%", end: "center 40%", scrub: true } });
    });
    $$(".sec-head, .step, .moment, .compare-wrap").forEach(function (el) {
      gsap.from(el, { y: 26, duration: 0.9, ease: "power3.out", scrollTrigger: { trigger: el, start: "top 88%" } });
    });
    addEventListener("load", function () { ScrollTrigger.refresh(); });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { ScrollTrigger.refresh(); });
  }
  function initCursor() {
    if (!finePointer || reduce || !document.body.classList.contains("mc-body")) return;
    var SIZES = [11, 10, 9, 8, 7, 6, 5], COLORS = ["#840010", "#B2883F", "#840010", "#B2883F", "#840010", "#B2883F", "#840010"];
    var dots = SIZES.map(function (s, i) { var d = document.createElement("span"); d.className = "dot-trail";
      d.style.width = d.style.height = s + "px"; d.style.background = COLORS[i]; d.style.opacity = 0; document.body.appendChild(d);
      return { el: d, x: -50, y: -50, s: s }; });
    var mx = -50, my = -50, on = false;
    addEventListener("pointermove", function (e) { mx = e.clientX; my = e.clientY; if (!on) { on = true; dots.forEach(function (d) { d.el.classList.add("live"); }); } });
    document.addEventListener("pointerleave", function () { on = false; dots.forEach(function (d) { d.el.classList.remove("live"); }); });
    (function tick() {
      var x = mx, y = my;
      dots.forEach(function (d, i) { d.x = lerp(d.x, x, i === 0 ? 0.5 : 0.36); d.y = lerp(d.y, y, i === 0 ? 0.5 : 0.36);
        d.el.style.transform = "translate(" + (d.x - d.s / 2 + 14) + "px," + (d.y - d.s / 2 + 14) + "px)"; d.el.style.opacity = on ? (1 - i * 0.1) : 0; x = d.x; y = d.y; });
      requestAnimationFrame(tick);
    })();
  }
  function initTilt() {
    if (!finePointer || reduce) return;
    document.addEventListener("pointermove", function (e) {
      var card = e.target.closest && e.target.closest(".tilt-cards .card");
      $$(".tilt-cards .card.tilting").forEach(function (c) { if (c !== card) { c.classList.remove("tilting"); c.style.transform = ""; c.style.setProperty("--go", 0); } });
      if (!card) return;
      var r = card.getBoundingClientRect(), px = (e.clientX - r.left) / r.width, py = (e.clientY - r.top) / r.height;
      card.classList.add("tilting");
      card.style.transform = "rotateY(" + (px - 0.5) * 9 + "deg) rotateX(" + (0.5 - py) * 7 + "deg) translateY(-4px)";
      card.style.setProperty("--gx", px * 100 + "%"); card.style.setProperty("--gy", py * 100 + "%"); card.style.setProperty("--go", 0.55);
    });
  }
  function initMagnet() {
    if (!finePointer || reduce) return;
    document.addEventListener("pointermove", function (e) {
      $$(".magnet").forEach(function (b) {
        var r = b.getBoundingClientRect(), cx = r.left + r.width / 2, cy = r.top + r.height / 2, dx = e.clientX - cx, dy = e.clientY - cy;
        var dist = Math.hypot(dx, dy), reach = Math.max(r.width, r.height) * 0.9;
        b.style.transform = dist < reach ? "translate(" + dx * 0.18 + "px," + dy * 0.25 + "px)" : "";
      });
    });
  }

  function boot() {
    initHeader(); initCart(); initOrdersClosed(); initCards(); initPDP(); initFinder(); initReviews(); initReviewForms();
    initWords(); initScroll(); initCursor(); initTilt(); initMagnet();
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot); else boot();
})();
